import { render } from "./AyudaExamAten.vue?vue&type=template&id=0949b356&scoped=true"
import script from "./AyudaExamAten.vue?vue&type=script&lang=js"
export * from "./AyudaExamAten.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=0949b356&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0949b356"]])

export default __exports__